import React, { useEffect, useState } from "react";
import axios from "axios";
import { FormControl, FormControlLabel, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialDialog from "../../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";
import MaterialSwitch from "../../../styles/materialSwitch";

const MANAGER_TYPES = ["cash", "bank", "crypto"];

const TelegramEditManagerDialog = ({ open, onClose, manager, setNotification, onSaved, t }) => {
  const [form, setForm] = useState({
    name: "",
    type: "crypto",
    telegramUserId: "",
    telegramUsername: "",
    email: "",
    isActive: true
  });

  useEffect(() => {
    if (manager) {
      setForm({
        name: manager.name,
        type: manager.type,
        telegramUserId: manager.telegramUserId || "",
        telegramUsername: manager.telegramUsername || "",
        email: manager.email || "",
        isActive: manager.isActive,
      });
    }
  }, [manager]);

  const handleEdit = () => {
    axios.put(`/api/telegram/managers/${manager.id}`, {
      name: form.name.trim(),
      type: form.type,
      telegramUserId: form.telegramUserId || null,
      telegramUsername: form.telegramUsername || null,
      email: form.email || null,
      isActive: form.isActive,
    }, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        onClose();
        setNotification({ visible: true, type: "success", message: t("managers.success.saved") });
        onSaved();
      }
    }).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("managers.errors.save")
      });
    });
  };

  return (
    <MaterialDialog open={open}>
      <StyledDialogWrapper>
        <StyledDialogHead>
          {t("managers.dialog.editTitle")}
        </StyledDialogHead>
        <StyledDialogContent>
          <TextField
            label={t("managers.dialog.name")}
            value={form.name}
            onChange={e => {
              const v = e.target.value;
              setForm(f => ({ ...f, name: v }));
            }}
            required
          />
          <FormControl fullWidth>
            <Autocomplete
              options={MANAGER_TYPES}
              value={form.type}
              onChange={(event, type) => setForm(f => ({ ...f, type: type || "crypto" }))}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField {...params} label={t("managers.dialog.type")} />
              )}
              blurOnSelect
              disableClearable
            />
          </FormControl>
          <TextField
            label={t("managers.dialog.telegramUserId")}
            value={form.telegramUserId}
            onChange={e => {
              const v = e.target.value;
              setForm(f => ({ ...f, telegramUserId: v }));
            }}
          />
          <TextField
            label={t("managers.dialog.telegramUsername")}
            value={form.telegramUsername}
            onChange={e => {
              const v = e.target.value;
              setForm(f => ({ ...f, telegramUsername: v }));
            }}
          />
          <TextField
            label={t("managers.dialog.email")}
            value={form.email}
            onChange={e => {
              const v = e.target.value;
              setForm(f => ({ ...f, email: v }));
            }}
            type="email"
          />
          <FormControlLabel
            control={<MaterialSwitch
              checked={form.isActive}
              onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))}
              color="primary"
            />}
            label={t("managers.dialog.isActive")}
          />
        </StyledDialogContent>
        <StyledDialogAction col="2">
          <DefaultButton onClick={onClose} color="danger">
            {t("managers.dialog.cancel")}
          </DefaultButton>
          <DefaultButton onClick={handleEdit} color="success">
            {t("managers.dialog.save")}
          </DefaultButton>
        </StyledDialogAction>
      </StyledDialogWrapper>
    </MaterialDialog>
  );
};

export default TelegramEditManagerDialog;